<template>
  <div class="qr-container" v-loading="loading">
    <div>
      <img :src="qrLink" ref="qr" />
      <icon-button size="20" icon="el-icon-printer" @click="print" class="print-button"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QR',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    qrLink () {
      return this.$apiUrl + this.$api.stations.qr(this.station.id)
    }
  },
  methods: {
    print () {
      const popup = window.open()
      popup.document.write(`<img src="${this.qrLink}" alt="">`)
      popup.focus()
      setTimeout(() => {
        popup.print()
      }, 500)
    }
  },
  mounted () {
    let interval = setInterval(() => {
      if (this.$refs.qr.complete) {
        this.loading = false
        clearInterval(interval)
      }
    }, 100)
  },
  created () {}
}
</script>

<style lang="scss" scoped>
  .print-button {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .qr-container {
    width: 490px;
    height: 490px;
    background-color: white;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 490px;
      height: 490px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/QR.vue